const namespace = 'ui-search-info-text-box';
const maxLength = 250;

export { namespace, maxLength };
